/**
 * Shared pipeline stage definitions
 */

export const STAGE_META = {
    qualification: {
        label: 'Qualification',
        probability: 10,
        probabilityMin: 0,
        probabilityMax: 10,
        color: '#FF9500',
        headerBg: '#fff3e0'
    },
    proposal: {
        label: 'Proposal/Price Quote',
        probability: 75,
        probabilityMin: 11,
        probabilityMax: 75,
        color: '#007AFF',
        headerBg: '#e3f2fd'
    },
    negotiation: {
        label: 'Negotiation/Review',
        probability: 99,
        probabilityMin: 76,
        probabilityMax: 99,
        color: '#ED6F42',
        headerBg: '#fce4ec'
    },
    closed: {
        label: 'Closed Won',
        probability: 100,
        probabilityMin: 100,
        probabilityMax: 100,
        color: '#34C759',
        headerBg: '#e8f5e9'
    },
    closedLost: {
        label: 'Closed Lost',
        probability: 0,
        probabilityMin: 0,
        probabilityMax: 0,
        color: '#8E8E93',
        headerBg: '#f5f5f5'
    }
};

export const STAGE_ORDER = ['qualification', 'proposal', 'negotiation', 'closed', 'closedLost'];

export function isClosedStage(stage) {
    return stage === 'closed' || stage === 'closedLost';
}

export function getStageLabel(key) {
    return STAGE_META[key]?.label || key;
}

export function getStageProbabilityRangeLabel(key) {
    const meta = STAGE_META[key];
    if (!meta) return '';
    if (meta.probabilityMin === meta.probabilityMax) {
        return `${meta.probabilityMax}%`;
    }
    return `${meta.probabilityMin}–${meta.probabilityMax}%`;
}

export function minProbabilityForStage(stage) {
    const meta = STAGE_META[stage];
    return meta ? meta.probabilityMin : 0;
}
